import { footerLinks } from "@/mocks/homeData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-8 max-w-6xl mx-auto py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
                <i className="ri-bookmark-3-fill" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">桃花视频导航</span>
            </div>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed max-w-md">
              一个专注于入口指引与地址同步的导航页。换域名、改版之后，请回到本页获取最新地址，
              并记得把本页收藏起来，做一个「永远不会走丢」的访客。
            </p>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-heading font-bold text-sm text-background-50">
              <a href="#top" className="cursor-pointer">页面导航</a>
            </h4>
            <div className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {footerLinks.map((link) => (
                <a
                  key={link.id}
                  href={`#${link.id}`}
                  className="text-sm text-background-200/80 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading font-bold text-sm text-background-50">
              <a href="#bookmark" className="cursor-pointer">快速收藏</a>
            </h4>
            <p className="mt-4 text-sm text-background-200/80 leading-relaxed">
              按 Ctrl+D（Mac 为 Command+D）即可收藏本页，换域名后也能顺着这里找回入口。
            </p>
            <a
              href="#bookmark"
              className="mt-4 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-bookmark-3-line" />
              去收藏
            </a>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-200/60">
            © {year} 桃花视频导航页 · 本页仅为入口指引与信息同步，不提供、不存储任何视频内容。
          </p>
          <p className="text-xs text-background-200/60">
            请以本页展示的入口为准，注意辨别仿冒地址。
          </p>
        </div>
      </div>
    </footer>
  );
}